/* eslint-disable import/prefer-default-export */
import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/recaudacion/lineas-vehiculares';

/**
 * GET Linea de Vehiculo
 * @returns {Promise<object|null>}
 */
export const getLineaDeVehiculo = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Lineas de Vehiculos
 * @returns {Promise<object[]>}
 */
export const getLineasDeVehiculos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    if (response.data.results?.length) {
      return response.data;
    }
  } catch (err) {
    onError(err);
  }
  return { results: [] };
};

/**
 * GET Lineas de Vehiculos
 * @returns {Promise<object[]>}
 */
export const getLineasDeVehiculosSinPaginar = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}-public`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Lineas de Vehiculos
 * @param {object} values
 * @returns {Promise<object[]>}
 */
export const postLineaDeVehiculos = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * PATCH Linea de Vehiculo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchLineaDeVehiculo = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Linea de Vehiculo
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteLineaDeVehiculo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
